import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getShoppingCartText (callback) {
    HTTP.get('/properties/cart_text').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setShoppingCartText (callback, param) {
    if (param !== undefined) {
      HTTP.put('/properties/cart_text', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/shopping_cart_text/index.js